import { Component, Input, OnInit } from '@angular/core';
import { PaymentService, AuthService, ErrorHandlerService, ViewportService } from 'epay-library';
import { IPaymentAccount } from 'epay-library/lib/features/common/models/payment/paymentaccount';
import { IEMPPaymentHistory } from 'epay-library/lib/features/employer/models/payment/achd/employerPaymentHistory';

@Component({
  selector: 'emp-payment-history-common',
  templateUrl: './emppayment-history-common.component.html'
})
export class EMPPaymentHistoryCommonComponent implements OnInit {
  @Input() baseurl = '';
  @Input() secondaryIdAlias = '';
  @Input() accountKeys: string[] = [];
  @Input() numOfDaysForPaymentHistory = 0;
  @Input() showParticipantCase = false;

  paymentHistoryHeaders: string[] = [];
  payorHistoryHeaders: string[] = [];
  paymentaccounts: IPaymentAccount[];
  payments: IEMPPaymentHistory[];
  errorMessage = '';
  isLoggedIn = false;
  payorType = '';
  isLoadingPaymemtHistory = false;
  isMobile = false;
  disableExpansion = false;

  constructor(
    private paymentService: PaymentService,
    private authservice: AuthService,
    private errorHandlerService: ErrorHandlerService,
    private viewpointService: ViewportService
  ) {
    this.paymentaccounts = [];
    this.payments = [];
    this.accountKeys = [];
  }

  ngOnInit() {
    if (this.showParticipantCase) {
      this.payorHistoryHeaders = [
        'Last Name',
        'First Name',
        'FSR #',
        'SSN',
        'Amount',
      ];
    } else {
      this.payorHistoryHeaders = ['Last Name', 'First Name', 'SSN', 'Amount'];
    }

    if (this.secondaryIdAlias !== '') {
      this.payorHistoryHeaders = [
        'Last Name',
        'First Name',
        this.secondaryIdAlias,
        'SSN',
        'Amount',
      ];
    }

    this.authservice.currentUserType
      .subscribe((type) => (this.payorType = type))
      .unsubscribe();

    this.authservice.isLoggedIn
      .subscribe((status) => (this.isLoggedIn = status))
      .unsubscribe();

    if (this.isLoggedIn) {
      this.isLoadingPaymemtHistory = true;
      this.paymentService.getPaymentAccounts(this.baseurl).subscribe({
        next: (accounts: any) => {
          this.paymentaccounts = accounts;
        },
        error: (error: any) => {
          this.errorMessage = error as any;
          this.isLoadingPaymemtHistory = false;
          this.logError(error);
          this.handleError(error.status);
        },
        complete: () => {
          this.paymentaccounts.forEach((key) => {
            this.paymentService
              .getPaymentHistory(
                this.baseurl,
                key.scheduledPaymentAccountKey,
                this.numOfDaysForPaymentHistory
              )
              .subscribe({
                next: (payments: any) => {
                  this.payments = this.payments.concat(
                    this.filterPrenotes(payments)
                  );
                  this.isLoadingPaymemtHistory = false;
                },
                error: (error: any) => {
                  this.errorMessage = error as any;
                  this.isLoadingPaymemtHistory = false;
                  this.logError(error);
                  this.handleError(error.status);
                },
              });
          });
        },
      });
      this.isLoadingPaymemtHistory = false;
    }

    this.viewpointService.IsMobile.subscribe((mobile) => {
      this.isMobile = mobile;
      if (this.isMobile) {
        this.paymentHistoryHeaders = ['Date', 'Bank Name', 'Amount'];
      } else {
        this.paymentHistoryHeaders = [
          'Date',
          'Nickname',
          'Bank Name',
          'Account',
          'Amount',
          'Frequency',
        ];
      }
    });
  }

  filterPrenotes(payments: IEMPPaymentHistory[]) {
    return payments.filter((x) => x.scheduleFrequency !== 'PRN');
  }

  logError(error: Error) {
    this.errorHandlerService.logError(error);
  }

  handleError(error: number) {
    console.log(this.errorMessage);
    console.log('error', error);
    this.errorHandlerService.handleErrorMessage(error, this.baseurl);
  }
}

